import * as types from './mutation-types'

export default {

  [types.ADD_QUIZS](state, quizs) {
    state.quizs = quizs.data
    state.meta_data = quizs.meta
  }
}
